import { SxStyles } from 'types';

export const popupImg: SxStyles = {
  width: '104px',
  height: '104px',
};

export const popupInnerBody: SxStyles = {
  padding: '24px',
  background: '#F3F4F9',
};

export const button: SxStyles = {
  width: '100%',
};
